<template>
    <div>
        <li class="header">NAVIGASI UTAMA</li>

        <li class="active">
            <router-link to="/reg_registrasi">
                <i class="material-icons">home</i>
                <span>Home</span>
            </router-link>
        </li>
    
        <li class="header">DATA MASTER</li>

        <li>
            <router-link to="/reg_office">
                <i class="material-icons">drafts</i>
                <span>Modul Office</span>
            </router-link>
        </li>
        <li>
            <router-link to="/reg_bhumie">
                <i class="material-icons">monetization_on</i>
                <span>Modul Bhumie</span>
            </router-link>
        </li>
        <li>
            <router-link to="/reg_simpeg">
                <i class="material-icons">people_outline</i>
                <span>Modul Simpeg</span>
            </router-link>
        </li>
        <li>
            <router-link to="/reg_planing">
                <i class="material-icons">domain</i>
                <span>Modul Planing</span>
            </router-link>
        </li>
        <li>
            <router-link to="/reg_sakip">
                <i class="material-icons">assessment</i>
                <span>Modul Sakip</span>
            </router-link>
        </li>

    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>





